import { BgColor, Color } from "./color";
import {
  ClimateRiskReportCategory,
  getClimateRiskLayerLabelKey,
  isColorlessClimateRiskCategory
} from "../types";

/**
 * 将数据数组转换为PDF表格行格式
 * @param dataArray 数据数组
 * @param svg SVG图标对象
 * @param t 翻译函数
 * @returns 格式化后的表格行数据
 */
export function formatTableRows(
  dataArray: any[][],
  svg: Record<string, string>,
  t: (key: string) => string,
  category: ClimateRiskReportCategory
): any[] {
  const hideMetricColors = isColorlessClimateRiskCategory(category);

  return dataArray.map((e) => {
    // 创建第一列（图标）和第二列（名称）
    const row: any[] = [
      svg[e[0]]
        ? {
            svg: svg[e[0]],
            fit: [12, 12],
            width: 12
          }
        : { text: "" },
      t(getClimateRiskLayerLabelKey(category, e[0])), //这一列需要根据相同数据来合并单元格
      e[1]
    ];

    const row1: any[] = [];
    // 添加数据列（从索引1到9）
    for (let i = 2; i <= 10; i++) {
      const isNoDataCell = isNaN(parseFloat(e[i]));
      row1.push({
        text: formatNumberValue(e[i]),
        style: { alignment: "center" },
        fillColor:
          hideMetricColors && isNoDataCell
            ? BgColor(e[i], category)
            : hideMetricColors
              ? undefined
              : BgColor(e[i], category),
        color: hideMetricColors ? undefined : Color(e[i], category)
      });
    }

    return [...row, ...row1];
  });
}

/**
 * 将输入值格式化为数字字符串，保留两位小数
 * 如果是有效数字，则格式化为两位小数的字符串
 * 如果不是有效数字，则将其转换为普通字符串
 *
 * @param value - 要格式化的值，可以是任意类型
 * @returns 格式化后的字符串，数字值保留两位小数
 */
function formatNumberValue(value: any): string {
  // 检查是否为有效的数字字符串
  const num = parseFloat(value);
  // 数字
  if (!isNaN(num)) {
    return num.toFixed(2);
  }
  // 非数字
  return "";
}
